import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';

const styles = css`
  width: 100%;
  height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 5vh 5vw;
  position: relative;
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: #000000;
    opacity: .3;
    z-index: 1;
  }
  img {
    -ms-interpolation-mode: bicubic;
    width: 85px;
    height: 85px;
  }

  h3 {
    font-size: 42px;
    font-weight: 300;
    color: ${colors.white};
    font-family: ${typography.Serif};
    font-style: italic;
    text-shadow: 0 1px 2px rgba(0,0,0,.6);
    z-index: 2;
    position: relative;
    line-height: 1;
    text-align: center;
    @media(min-width: 992px) {
      font-size: 60px;
    }
  }

  p {
    font-size: 18px;
    color: ${colors.white};
    text-align: center;
    position: relative;
    z-index: 2;
    text-shadow: 0 1px 2px rgba(0,0,0,.6);
    @media(min-width: 992px) {
      font-size: 24px;
    }
  }
  a {
    position: relative;
    z-index: 2;
  }
  .ButtonDefault {
    padding-right: 60px;
  }
`;

function HomePageBanner({ page }) {
  return (
    <div>
      {
        get(page.energy_difference[0], 'lead_copy') &&
        <div className={styles} style={{ backgroundImage: `url(${buildThumbnailUrl(get(page, 'energy_difference[0].image_bg.contentUrl'), { width: 1600, height: 1600 })})` }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-lg-auto text-center">
                <h3>{get(page.energy_difference[0], 'lead_copy')}</h3>
                <p>{get(page.energy_difference[0], 'body_copy')}</p>
                <Link name="about-us" className="btn">{get(page.energy_difference[0], 'button_text')}</Link>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

HomePageBanner.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'homepage',
  },
)(HomePageBanner);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomePageBanner.js